import Product from "interfaces/response/Product";
import AdminProduct from "interfaces/response/AdminProduct";
import ProductRequest from "interfaces/request/ProductRequest";
import { getDataAsync, putDataAsync, postDataAsync, deleteDataAsync } from "./PortalApi";

export const getProductAsync = (productId: number) => {
  const url = `Products/${productId}`;
  return getDataAsync<Product>(url);
};

export const getAllProductsAsync = async(includeActiveonly = false) => {
  // We need to send includeActiveOnly=false as Query Param else only active products will be selected.
  const routeUrl = `Products?includeActiveOnly=${includeActiveonly}`; 
  const response = await getDataAsync<AdminProduct[]>(routeUrl);

  return response;
};

export const createProductAsync = async(data: ProductRequest) => {
  const routeUrl = `Products`;

  return await postDataAsync<ProductRequest, AdminProduct>(routeUrl, data);
}

export const updateProductAsync = async (productId: number, data: ProductRequest) => {
  const routeUrl = `Products/${productId}`;

  return await putDataAsync<ProductRequest, AdminProduct>(routeUrl, data);
};

export const deleteProductAsync = async (productId: number) => {
  const routeUrl = `Products/${productId}`;

  return await deleteDataAsync(routeUrl);
};
